export default __webpack_public_path__ + "static/18.jamiyah@2x-1c285de582178dc8cc5f0b1c0e202dbb.png";